import { Button, Grid, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from 'react';

const SourceText = ({ source, onSubmit = (text) => {} , onSourceTextChange = (text) => {} }) => {
    const [t,] = useTranslation('global');
    const [text, setText] = useState(source ?? '');

    return (
        <Grid container spacing={2} className="source-text-container">
            <Grid item xs={8}>
                <h2>{t('sourceText.title')}</h2>
            </Grid>
            <Grid item xs={12}>
                <TextField className="source-text-textfield"
                        multiline
                        variant="standard"
                        fullWidth
                        value={text}
                        onChange={(e) => {
                            const txt = e.target.value;
                            setText(txt);
                            onSourceTextChange(txt);
                        }}
                        rows={8} 
                        InputProps={{
                        disableUnderline: true,
                        style: { 
                            fontSize: 14, 
                            borderRadius: 16, 
                            backgroundColor: 'white',
                            padding: 8
                        }}}
                />
            </Grid>
            <Grid item xs={4}>
                <button type="button" className="find-similar-btn" onClick={() => onSubmit(text)}>
                    <span className="material-symbols-outlined">search</span>
                    <span className="find-similar">{t('sourceText.findSimilar')}</span>   
                </button>
            </Grid>
        </Grid>
    );
}

export default SourceText;